import React, { useEffect, useState, useContext } from "react";

// plugin imports
import { ReactLenis } from "lenis/react";
import { cancelFrame, frame } from "motion/react";

// context imports
import { LayoutContext } from "../../context/layoutContext";

// style imports

// component imports

// svg imports

// component
export default function SmoothScroll({ children, root = false }) {
	const lenisRef = React.useRef(null);
	const { projectOpen } = useContext(LayoutContext);

	useEffect(() => {
		function update(data) {
			const time = data.timestamp;
			lenisRef.current?.lenis?.raf(time);
		}

		frame.update(update, true);

		return () => cancelFrame(update);
	}, []);

	useEffect(() => {
		const lenis = lenisRef.current?.lenis;
		if (!lenis || !root) return;

		let rafId;

		if (projectOpen) {
			const checkAndStop = () => {
				if (!lenis.isAnimating) {
					lenis.stop();
				} else {
					rafId = requestAnimationFrame(checkAndStop);
				}
			};
			rafId = requestAnimationFrame(checkAndStop);
		} else {
			lenis.start();
		}

		return () => {
			if (rafId) cancelAnimationFrame(rafId);
		};
	}, [projectOpen, root]);

	const [isUsingMouse, setIsUsingMouse] = useState(false);
	useEffect(() => {
		function handleWheel(e) {
			function isLikelyMouseWheel(e) {
				// Check if deltaMode is in "lines" (1) or "pages" (2), which points to a mouse wheel
				if (e.deltaMode !== 0) return true;

				// Check for large, integer steps characteristic of a traditional mouse wheel
				const looksLikeMouseStep =
					Math.abs(e.deltaY) > 30 && Math.abs(e.deltaX) === 0;

				// Pinch-to-zoom on some platforms sets ctrlKey, do not treat as scroll pan
				const isPinch = e.ctrlKey === true || e.metaKey === true;

				// If it looks like a mouse step and is not a pinch gesture, it is likely a mouse wheel
				return looksLikeMouseStep && !isPinch;
			}

			setIsUsingMouse(isLikelyMouseWheel(e));
			window.removeEventListener("wheel", handleWheel);
		}

		window.addEventListener("wheel", handleWheel);
		return () => window.removeEventListener("wheel", handleWheel);
	}, []);

	return (
		<ReactLenis
			root={root}
			options={{ autoRaf: false, smoothWheel: isUsingMouse }}
			ref={lenisRef}
		>
			{children}
		</ReactLenis>
	);
}
